module.exports = "https://cdn.dove.it/_next/static/public/assets/work-with-us/hero-desktop.d0060594cc3a2c585c00311148bb6ea9.jpg";